export const ONBOARDING_SET_MODE        = "ONBOARDING_SET_MODE";
export const ONBOARDING_SET_STEP        = "ONBOARDING_SET_STEP";
export const ONBOARDING_SET_ANSWERS     = "ONBOARDING_SET_ANSWERS";
export const ONBOARDING_TICK_CHECKLIST  = "ONBOARDING_TICK_CHECKLIST";
export const ONBOARDING_RESET           = "ONBOARDING_RESET";
export const ONBOARDING_HYDRATE         = "ONBOARDING_HYDRATE";
